export const DATASETS_HIDDEN_TAGS = ['vqe data available', 'xanadu']
